<template>
  <tbody>
    <slot></slot>
  </tbody>
</template>
